import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { ReconciliationRouteModule } from './reconciliation.route';
import { ReconciliationContainerComponent } from './reconciliation-container/reconciliation-container.component';
import { SharedModule } from '../shared/shared.module';
import { ReconciliationComponent } from './reconciliation/reconciliation.component';
import { ReconciliationFiltersComponent } from './reconciliation-filters/reconciliation-filters.component';
import { ReconciliationExportComponent } from './reconciliation-export/reconciliation-export.component';
import { ReconciliationFileFormatComponent } from './reconciliation-file-format/reconciliation-file-format.component';
import { ReconciliationShareTemplatePopupComponent } from './reconciliation-share-template-popup/reconciliation-share-template-popup.component';
import { ReconciliationMemorizeTemplatePopupComponent } from './reconciliation-memorize-template-popup/reconciliation-memorize-template-popup.component';

@NgModule({
    declarations: [
        ReconciliationContainerComponent,
        ReconciliationComponent,
        ReconciliationFiltersComponent,
        ReconciliationExportComponent,
        ReconciliationFileFormatComponent,
        ReconciliationShareTemplatePopupComponent,
        ReconciliationMemorizeTemplatePopupComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        ReconciliationRouteModule,
    ]
})
export class ReconciliationModule {}
